// Silencio Low Noise Drainage System Catalog
// HSN CODE: 39172390

export const silencioCatalog = {
    page: 1,
    title: "ASTRAL SILENCIO - THE COMPLETE LOW NOISE DRAINAGE SYSTEM",
    hsn_code: "39172390",
    description: "Low noise drainage pipes with German technology - 3 layer construction and special socket joint",
    features: [
        "3 Layer Construction - External PP Layer, Mineral Reinforced PP, Internal Polypropylene",
        "Special Socket Joint for noise insulation",
        "Push-fit Socket with Special Ring for hydraulic tightness",
        "External Ribs on socket for impact resistance",
        "Door Fittings - Under the system the threaded door cap helps maintain constant flow",
        "Depth Gauge - For accurate pipe depth measurement",
        "Swept Angle - 87.5° swept angle incorporated for smooth flow"
    ],
    sections: [
        {
            name: "PIPES (3M QS)",
            length: "3M QS",
            items: [
                { size_mm: "40", length: "3M QS", product_code: "M24270304", std_pkg: 62, price_inr_per_pc: 1154.00 },
                { size_mm: "40", length: "3M QIS", product_code: "M24081034", std_pkg: 52, price_inr_per_pc: 1239.00 },
                { size_mm: "40", length: "1 RFT QS", product_code: "M24271014", std_pkg: 1, price_inr_per_pc: 376.00 },
                { size_mm: "40", length: "2 RFT QIS", product_code: "M24083024", std_pkg: 1, price_inr_per_pc: 876.00 },
                { size_mm: "40", length: "3 RFT QIS", product_code: "M24283304", std_pkg: 1, price_inr_per_pc: 441.00 },
                { size_mm: "40", length: "4 RFT QIS", product_code: "M24284404", std_pkg: 1, price_inr_per_pc: 688.00 },
                { size_mm: "40", length: "6 RFT QIS", product_code: "M24086604", std_pkg: 1, price_inr_per_pc: 911.00 },
                { size_mm: "40", length: "6 RFT QIS", product_code: "M24286604", std_pkg: 1, price_inr_per_pc: 1014.00 },
                { size_mm: "50", length: "3M QIS", product_code: "M24270305", std_pkg: 52, price_inr_per_pc: 1405.00 },
                { size_mm: "50", length: "3M QIS", product_code: "M24270305", std_pkg: 52, price_inr_per_pc: 1548.00 },
                { size_mm: "50", length: "1 RFT QIS", product_code: "M24271015", std_pkg: 1, price_inr_per_pc: 503.00 },
                { size_mm: "50", length: "2 RFT QIS", product_code: "M24092025", std_pkg: 1, price_inr_per_pc: 471.00 },
                { size_mm: "50", length: "3 RFT QIS", product_code: "M24283305", std_pkg: 1, price_inr_per_pc: 654.00 },
                { size_mm: "50", length: "4 RFT QIS", product_code: "M24294405", std_pkg: 1, price_inr_per_pc: 858.00 },
                { size_mm: "50", length: "6 RFT QIS", product_code: "M24296605", std_pkg: 1, price_inr_per_pc: 1049.00 },
                { size_mm: "50", length: "6 RFT QIS", product_code: "M24296605", std_pkg: 1, price_inr_per_pc: 1075.00 },
                { size_mm: "63", length: "3M QS", product_code: "M24270306", std_pkg: 30, price_inr_per_pc: 1639.00 },
                { size_mm: "63", length: "3M QIS", product_code: "M24081036", std_pkg: 30, price_inr_per_pc: 1732.00 },
                { size_mm: "63", length: "1 RFT QS", product_code: "M24271016", std_pkg: 1, price_inr_per_pc: 169.00 },
                { size_mm: "63", length: "2 RFT QIS", product_code: "M24082026", std_pkg: 1, price_inr_per_pc: 878.00 },
                { size_mm: "63", length: "3 RFT QIS", product_code: "M24283306", std_pkg: 1, price_inr_per_pc: 701.00 },
                { size_mm: "63", length: "4 RFT QIS", product_code: "M24284406", std_pkg: 1, price_inr_per_pc: 930.00 },
                { size_mm: "63", length: "6 RFT QS", product_code: "M24276606", std_pkg: 1, price_inr_per_pc: 1166.00 },
                { size_mm: "63", length: "6 RFT QIS", product_code: "M24386606", std_pkg: 1, price_inr_per_pc: 1171.00 },
                { size_mm: "75", length: "3M QS", product_code: "M24270307", std_pkg: 36, price_inr_per_pc: 1836.00 },
                { size_mm: "75", length: "3M QIS", product_code: "M24081037", std_pkg: 36, price_inr_per_pc: 1873.00 },
                { size_mm: "75", length: "1 RFT QS", product_code: "M24271017", std_pkg: 1, price_inr_per_pc: 186.00 },
                { size_mm: "75", length: "2 RFT QIS", product_code: "M24082027", std_pkg: 1, price_inr_per_pc: 527.00 },
                { size_mm: "75", length: "3 RFT QIS", product_code: "M24283307", std_pkg: 1, price_inr_per_pc: 764.00 },
                { size_mm: "75", length: "4 RFT QIS", product_code: "M24084407", std_pkg: 1, price_inr_per_pc: 969.00 },
                { size_mm: "75", length: "6 RFT QS", product_code: "M24276607", std_pkg: 1, price_inr_per_pc: 1360.00 },
                { size_mm: "75", length: "6 RFT QIS", product_code: "M24286607", std_pkg: 1, price_inr_per_pc: 1381.00 },
                { size_mm: "110", length: "3M QS", product_code: "M24270309", std_pkg: 18, price_inr_per_pc: 2945.00 },
                { size_mm: "110", length: "3M QIS", product_code: "M24270309", std_pkg: 18, price_inr_per_pc: 3003.00 },
                { size_mm: "110", length: "1 RFT QS", product_code: "M24271109", std_pkg: 1, price_inr_per_pc: 299.00 },
                { size_mm: "110", length: "2 RFT QIS", product_code: "M24092029", std_pkg: 1, price_inr_per_pc: 737.00 },
                { size_mm: "110", length: "3 RFT QIS", product_code: "M24283309", std_pkg: 1, price_inr_per_pc: 1085.00 },
                { size_mm: "110", length: "4 RFT QIS", product_code: "M24294409", std_pkg: 1, price_inr_per_pc: 1429.00 },
                { size_mm: "110", length: "6 RFT QS", product_code: "M24276609", std_pkg: 1, price_inr_per_pc: 2191.00 },
                { size_mm: "110", length: "6 RFT QIS", product_code: "M24286609", std_pkg: 1, price_inr_per_pc: 2035.00 }
            ]
        },
        {
            name: "PIPES (3M QIS & Other Lengths)",
            length: "Various",
            items: [
                { size_mm: "125", length: "3M QS", product_code: "M24270310", std_pkg: 15, price_inr_per_pc: 3468.00 },
                { size_mm: "125", length: "3M QIS", product_code: "M24081010", std_pkg: 15, price_inr_per_pc: 3364.00 },
                { size_mm: "125", length: "1 RFT QS", product_code: "M24271110", std_pkg: 1, price_inr_per_pc: 374.00 },
                { size_mm: "125", length: "2 RFT QIS", product_code: "M24082210", std_pkg: 1, price_inr_per_pc: 839.00 },
                { size_mm: "125", length: "3 RFT QIS", product_code: "M24283310", std_pkg: 1, price_inr_per_pc: 1299.00 },
                { size_mm: "125", length: "4 RFT QIS", product_code: "M24294410", std_pkg: 1, price_inr_per_pc: 1702.00 },
                { size_mm: "125", length: "6 RFT QS", product_code: "M24276610", std_pkg: 1, price_inr_per_pc: 2384.00 },
                { size_mm: "125", length: "6 RFT QIS", product_code: "M24076612", std_pkg: 1, price_inr_per_pc: 3002.00 },
                { size_mm: "160", length: "3M QIS", product_code: "M24270312", std_pkg: 12, price_inr_per_pc: 4768.00 },
                { size_mm: "160", length: "1 RFT QIS", product_code: "M24271012", std_pkg: 1, price_inr_per_pc: 474.00 },
                { size_mm: "160", length: "2 RFT QIS", product_code: "M24082212", std_pkg: 1, price_inr_per_pc: 1155.00 },
                { size_mm: "160", length: "3 RFT QIS", product_code: "M24283312", std_pkg: 1, price_inr_per_pc: 1573.00 },
                { size_mm: "160", length: "4 RFT QIS", product_code: "M24284412", std_pkg: 1, price_inr_per_pc: 2273.00 },
                { size_mm: "160", length: "6 RFT QS", product_code: "M24076612", std_pkg: 1, price_inr_per_pc: 3002.00 },
                { size_mm: "200", length: "3M QS", product_code: "M24270314", std_pkg: 9, price_inr_per_pc: 6979.00 },
                { size_mm: "200", length: "1 RFT QS", product_code: "M24271114", std_pkg: 1, price_inr_per_pc: 705.00 },
                { size_mm: "200", length: "2 RFT QIS", product_code: "M24082214", std_pkg: 1, price_inr_per_pc: 1345.00 },
                { size_mm: "200", length: "3 RFT QIS", product_code: "M24283314", std_pkg: 1, price_inr_per_pc: 2420.00 },
                { size_mm: "200", length: "4 RFT QIS", product_code: "M24284414", std_pkg: 1, price_inr_per_pc: 3229.00 },
                { size_mm: "200", length: "6 RFT QS", product_code: "M24276614", std_pkg: 1, price_inr_per_pc: 4248.00 },
                { size_mm: "200", length: "6 RFT QIS", product_code: "M24284614", std_pkg: 1, price_inr_per_pc: 4364.00 },
                { size_mm: "250", length: "3M QS", product_code: "M24270316", std_pkg: 6, price_inr_per_pc: 14323.00 },
                { size_mm: "250", length: "3M QIS", product_code: "M24281916", std_pkg: 6, price_inr_per_pc: 14271.00 },
                { size_mm: "250", length: "1 RFT QS", product_code: "M24271116", std_pkg: 1, price_inr_per_pc: 1454.00 },
                { size_mm: "250", length: "2 RFT QIS", product_code: "M24282216", std_pkg: 1, price_inr_per_pc: 2852.00 },
                { size_mm: "250", length: "3 RFT QIS", product_code: "M24283316", std_pkg: 1, price_inr_per_pc: 4278.00 },
                { size_mm: "250", length: "4 RFT QIS", product_code: "M24284416", std_pkg: 1, price_inr_per_pc: 5705.00 },
                { size_mm: "250", length: "6 RFT QIS", product_code: "M24284616", std_pkg: 1, price_inr_per_pc: 8560.00 }
            ]
        }
    ]
};

// Helper function to format price in INR
export const formatPrice = (price) => {
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price);
};

// Helper function to get all Silencio products as flat array
export const getAllSilencioProducts = () => {
    const allProducts = [];
    silencioCatalog.sections.forEach((section, sectionIndex) => {
        section.items.forEach((item, itemIndex) => {
            allProducts.push({
                id: `silencio-${sectionIndex}-${itemIndex}`,
                ...item,
                sectionName: section.name,
                hsnCode: silencioCatalog.hsn_code
            });
        });
    });
    return allProducts;
};

// Get unique sizes for filter
export const getSilencioSizes = () => {
    const allProducts = getAllSilencioProducts();
    return [...new Set(allProducts.map(p => p.size_mm))].sort((a, b) => parseInt(a) - parseInt(b));
};

// Get unique lengths for filter
export const getSilencioLengths = () => {
    const allProducts = getAllSilencioProducts();
    return [...new Set(allProducts.map(p => p.length))];
};
